export enum PROPERTY_NEIGHBORHOOD_OPTION {
  NEIGHBORHOOD_NAME_UNEXISTENT = "동명 없음",
}
